
export const getSelfRatingLabel = (value: string): string => {
  switch (value) {
    case "far-below-expectations":
      return "Far Below Expectations";
    case "below-expectations":
      return "Below Expectations";
    case "meets-expectations":
      return "Meets Expectations";
    case "exceeds-expectations":
      return "Exceeds Expectations";
    case "far-exceeds-expectations":
      return "Far Exceeds Expectations";
    default:
      return "";
  }
};

export const getManagerRatingLabel = (value: string): string => {
  switch (value) {
    case "far-below-expectations":
      return "Far Below Expectations";
    case "below-expectations":
      return "Below Expectations";
    case "meets-expectations":
      return "Meets Expectations";
    case "exceeds-expectations":
      return "Exceeds Expectations";
    case "far-exceeds-expectations":
      return "Far Exceeds Expectations";
    default:
      return "";
  }
};

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    year: 'numeric',
    month: 'short',
    day: '2-digit'
  });
};
